module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0098.jpg?v=0e27f317";